import { FC } from 'react';
import { Dialog } from 'primereact/dialog';
import { FlaskConical, X } from 'lucide-react';

interface Props {
  onStart: () => void;
  onDismiss: () => void;
  videoUrl?: string | null;
}

export const BetaWelcomeDialog: FC<Props> = ({ onStart, onDismiss, videoUrl }) => (
  <Dialog
    visible
    onHide={onDismiss}
    className={`nc_beta-welcome ${videoUrl ? '' : 'nc_beta-welcome--text-only'}`}
    showHeader={false}
    closeOnEscape
    dismissableMask
  >
    <div className="nc_beta-welcome__text">
      <span className="nc_beta-welcome__chip">
        <FlaskConical size={16} aria-hidden="true" />
        Beta
      </span>

      <h2 className="nc_beta-welcome__title">A new way to get around</h2>

      <div className="nc_beta-welcome__copy">
        <p className="nc_beta-welcome__body">
          You’re part of a small group{' '}
          <span className="nc_beta-welcome__emphasis">trying out an early version of our new navigation.</span>
        </p>
        <p className="nc_beta-welcome__body">
          Nothing is final, we’ll ask what you think once you’ve used it for a while.
        </p>
      </div>

      <div className="nc_beta-welcome__actions">
        <button type="button" id="betaWelcomeStartButton" className="nc_beta-welcome__start" onClick={onStart}>
          Show me around
        </button>
      </div>
    </div>

    {videoUrl && (
      <div className="nc_beta-welcome__demo">
        <video
          className="nc_beta-welcome__video"
          src={videoUrl}
          autoPlay
          loop
          muted
          playsInline
          aria-label="A short demo of the new navigation"
        />
      </div>
    )}

    <button type="button" className="nc_beta-welcome__close" aria-label="Close" onClick={onDismiss}>
      <X size={20} aria-hidden="true" />
    </button>
  </Dialog>
);

export default BetaWelcomeDialog;
